import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleLargeDotted = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.875 12C3.875 7.51269 7.51269 3.875 12 3.875C16.4873 3.875 20.125 7.51269 20.125 12C20.125 16.4873 16.4873 20.125 12 20.125C7.51269 20.125 3.875 16.4873 3.875 12ZM12 1.625C6.27005 1.625 1.625 6.27005 1.625 12C1.625 17.7299 6.27005 22.375 12 22.375C17.7299 22.375 22.375 17.7299 22.375 12C22.375 6.27005 17.7299 1.625 12 1.625ZM12.0005 8.62512C10.1366 8.62512 8.62549 10.1362 8.62549 12.0001C8.62549 13.864 10.1366 15.3751 12.0005 15.3751C13.8644 15.3751 15.3755 13.864 15.3755 12.0001C15.3755 10.1362 13.8644 8.62512 12.0005 8.62512Z",
		fill: "currentColor"
	})]
});
export default SvgCircleLargeDotted;
